import React, { useEffect, useState, useCallback } from "react";
import { Spinner } from "reactstrap";
import api from "../../../services/api";
import { AUTOPILOT_COLORS } from "../../../components/autopilot/styles";
import { VigenciaBadge } from "./capacidadeBadges";
import { drawerEmptyStyle } from "./detalheDrawer.styles";

// Aba "Tabela de Frete" do drawer (H3, PO1-2620). Reuso puro de
// GET /frete/tabelas (já existe, aceita idEmbarcador+idTransportadora) — sem
// endpoint novo. O ciclo rascunho→vigência é só uma classificação client-side
// em cima de Status + DataValIni/DataValFim, replicando a convenção do badge
// de VinculoConectorTab.jsx (decisão fechada no kickoff da spec).
export function classificarVigencia({ status, dataValIni, dataValFim }) {
  if (!status) return "Rascunho";
  const hoje = new Date().toISOString().slice(0, 10);
  if (dataValIni && dataValIni > hoje) return "Rascunho";
  if (dataValFim && dataValFim < hoje) return "Expirada";
  return "Vigente";
}

const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0.55rem 0",
  borderBottom: `1px solid ${AUTOPILOT_COLORS.borderFaint}`,
};

export default function FreteTabelaResumoTab({ transportadoraId, embarcadorId }) {
  const [loading, setLoading] = useState(false);
  const [tabelas, setTabelas] = useState([]);
  const [erro, setErro] = useState("");

  const carregar = useCallback(async () => {
    if (!transportadoraId || !embarcadorId) return;
    setLoading(true);
    setErro("");
    try {
      const { data } = await api.get("/frete/tabelas", {
        params: { idEmbarcador: embarcadorId, idTransportadora: transportadoraId, limit: 100 },
      });
      setTabelas((data && data.rows) || []);
    } catch (e) {
      setErro(e?.response?.data?.error || "Falha ao carregar as tabelas de frete.");
    } finally {
      setLoading(false);
    }
  }, [transportadoraId, embarcadorId]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  if (!embarcadorId) {
    return <div style={drawerEmptyStyle}>Selecione um embarcador para ver as tabelas de frete.</div>;
  }
  if (loading) {
    return <div style={{ textAlign: "center", padding: "1.5rem" }}><Spinner size="sm" color="info" /></div>;
  }
  if (erro) {
    return <div style={drawerEmptyStyle}>{erro}</div>;
  }
  if (!tabelas.length) {
    return <div style={drawerEmptyStyle}>Nenhuma tabela de frete cadastrada para esta transportadora.</div>;
  }

  const pendencias = tabelas.filter((t) => classificarVigencia(t) !== "Vigente").length;

  return (
    <div>
      {pendencias > 0 && (
        <div style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.78rem", marginBottom: "0.5rem" }}>
          {pendencias} tabela{pendencias === 1 ? "" : "s"} para ativar
        </div>
      )}
      {tabelas.map((t) => (
        <div key={t.id} style={rowStyle}>
          <div>
            <div style={{ color: AUTOPILOT_COLORS.text, fontSize: "0.85rem" }}>{t.nome}</div>
            <div style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.72rem" }}>
              {t.servico || "—"} {t.dataValIni ? `· ${String(t.dataValIni).slice(0, 10)}` : ""}
              {t.dataValFim ? ` → ${String(t.dataValFim).slice(0, 10)}` : ""}
            </div>
          </div>
          <VigenciaBadge estado={classificarVigencia(t)} />
        </div>
      ))}
    </div>
  );
}
